import { render, staticRenderFns } from "./purchasecomplete.vue?vue&type=template&id=1da57cd8&scoped=true"
import script from "./purchasecomplete.vue?vue&type=script&lang=js"
export * from "./purchasecomplete.vue?vue&type=script&lang=js"
import style0 from "./purchasecomplete.vue?vue&type=style&index=0&id=1da57cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da57cd8",
  null
  
)

export default component.exports